import React from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import '../bookpage.css'
import Title from '../../components/Title/Title';

export default function RetreatFromTemptation() {
  return (
    <PageLayout>
      <div className="book-page">
        <Title title="Retreat immediately from sources of temptation; FLEE!" />
        <blockquote>
          “Now flee from youthful lusts, and pursue righteousness, faith, love and peace, with those who call on the Lord with a pure heart.” (2 Timothy 2:22)
        </blockquote>

        <p>Quickly remove yourself from the presence of whatever is tempting you. The longer we stay in its presence, the longer we allow ourselves to see the temptation and think on it. We then become more curious and interested, and then it will be harder to resist temptation. Cut off the ability for Satan to put his thoughts and images into your head. Turn off the television immediately or leave the room or building immediately if immoral or sinful things are being portrayed. If tempted to lust for a woman or man, or if you are tempted when you see cigarettes or alcohol or other things that have the power to control you, immediately look away; look up, down, or sideways, but DON’T LOOK. When we look, we focus attention; when we focus attention, our resolve to resist is replaced by curiosity, familiarity, and then desire. Turn away, then get away. Physically remove yourself from things that are tempting. Memorize Proverbs 4:23-27 and practice it until it becomes a well-ingrained habit. Finally, take whatever precautions you can to ensure that you cannot go back to the things that tempt you. Lock the door behind you. You cannot successfully resist temptation if you remain in the presence of the things that tempt you.</p>
        <br />

        <ul>
          <li>
            <strong>Flee from the source of temptation whenever it is possible to do so. Get out of temptation’s reach.</strong><br />
            <em>Genesis 39:12, 1 Corinthians 5:11, 6:18, 10:14, 15:33, 1 Timothy 6:10-11</em>
          </li>
          <br />
          <li>
            <strong>“Tear it out” and “cut it off”; remove the things from your life that make you stumble.</strong><br />
            <em>Matthew 5:29-30, Romans 13:14</em>
          </li>
          <br />
          <li>
            <strong>Restrain your feet from every evil way. Don’t go there!</strong><br />
            <em>Psalm 119:101, Proverbs 4:23-27, 5:7-8, 7:6-9, 19:16, 27:12</em>
          </li>
          <br />
          <li>
            <strong>Be sensitive and obedient to God’s prompting.</strong><br />
            <em>Romans 8:12-14</em>
          </li>
          <br />
          <li>
            <strong>Don’t “gaze into the cup,” don’t stare at those things that tempt you.</strong><br />
            <em>2 Samuel 11:1-4, Proverbs 6:25, 23:30-35</em>
          </li>
          <br />
          <li>
            <strong>Look for and take advantage of the way of escape that God always provides.</strong><br />
            <em>1 Corinthians 10:13</em>
          </li>
          <br />
          <li>
            <strong>Run to the Lord. Find refuge in Christ. Call upon His Name. Find protection in His Word.</strong><br />
            <em>Psalm 31:1-5, 19, 61:1-4, 91:1-4, 9-16, 119:114, 121:7-8, Proverbs 6:23-25, 18:10, 30:5, Matthew 11:28-30, John 8:31-32</em>
          </li>
          <br />
          <li>
            <strong>Learn from the situation; observe the patterns of temptation and learn to anticipate where and when temptation will appear and avoid it in the future.</strong><br />
            <em>Proverbs 22:3</em>
          </li>
        </ul>

      </div>
    </PageLayout>
  );
};
